import React, { SetStateAction, useState } from "react";
import { ButtonBase } from "@reusejs/react";
import { XIcon } from "@heroicons/react/solid";

interface NameMismatchModal {
  DocType: String;
  message: String;
  setModal: React.Dispatch<SetStateAction<boolean>>;
  callback: () => void;
}
const NameMismatchModal: React.FC<NameMismatchModal> = ({
  setModal,
  DocType,
  message,
  callback,
}) => {
  const [showContact, setShowContact] = useState<any>(false);
  return (
    <div>
      {DocType === "PAN" || DocType === "PAN_Warning" ? (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
          <div className="relative bg-white shadow-lg rounded-lg max-w-lg w-full">
            <h1 className="text-xl font-medium not-italic leading-6 text-gray-500 text-center w-full p-4 bg-red-200 border-b border-gray-500">
              {DocType === "PAN_Warning" ? `Warning!` : `Validation Failed!`}
            </h1>
            <div className="absolute top-4 right-4">
              <div
                className="cursor-pointer bg-gray-50 rounded-full p-1 border text-gray-900"
                onClick={() => setModal(false)}
              >
                <XIcon className="h-4 w-4" aria-hidden="true" />
              </div>
            </div>
            <div className="p-4">
              <div className="w-full border-gray-300 rounded-lg p-2 text-gray-500 text-center">
                {message}
              </div>

              {/*  Add This In case you want to update the name in the onboarding form.
              {!showContact ? (
                <div>
                  <div className="w-full border-gray-300 rounded-lg p-2 text-gray-700 text-center">
                    Do you want to change the name according to the PAN Card?
                  </div>
                  <div className="flex justify-center space-x-3 mt-4">
                    <ButtonBase
                      buttonBaseClasses={{ backgroundColor: "" }}
                      type="submit"
                      label={"Yes"}
                      onClick={() => {
                        callback();
                        setModal(false);
                      }}
                    />
                    <ButtonBase
                      buttonBaseClasses={{
                        backgroundColor: "bg-white",
                        border: "border border-blue-500 hover:border-blue-700",
                        textColor: "text-blue-500 hover:text-blue-700",
                      }}
                      type="submit"
                      label={"No"}
                      onClick={() => setShowContact(true)}
                    />
                  </div>
                </div>
              ) : (
                <div>
                  <div className="w-full border-gray-300 rounded-lg p-2 text-gray-500 text-center">
                    Contact Auction Bazaar here
                  </div>
                  <div className="w-full border-gray-300 rounded-lg p-2 text-gray-500 text-center">
                    Phone Number-8370969696
                  </div>
                  <div className="w-full border-gray-300 rounded-lg p-2 text-gray-500 text-center">
                    Email-contact@auctionbazaar.com
                  </div>
                </div>
              )} */}

              {/* This Div for Simply showing error message */}
              <div>
                <div className="w-full border-gray-300 rounded-lg p-2 text-gray-500 text-center">
                  Contact Auction Bazaar here
                </div>
                <div className="w-full border-gray-300 rounded-lg p-2 text-gray-500 text-center">
                  Phone Number-{" "}
                  <span className="text-blue-300">8370969696</span>
                </div>
                <div className="w-full border-gray-300 rounded-lg p-2 text-gray-500 text-center">
                  Email-
                  <span className="text-blue-300">
                    contact@auctionbazaar.com
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
          <div className="relative bg-white shadow-lg rounded-lg max-w-lg w-full">
            <h1 className="text-xl font-medium not-italic leading-6 text-gray-500 text-center w-full p-4 bg-red-200 border-b border-gray-500">
              Validation Failed!
            </h1>
            <div className="absolute top-4 right-4">
              <div
                className="cursor-pointer bg-gray-50 rounded-full p-1 border text-gray-900"
                onClick={() => setModal(false)}
              >
                <XIcon className="h-4 w-4" aria-hidden="true" />
              </div>
            </div>
            <div className="p-4">
              <div className="w-full border-gray-300 rounded-lg p-2 text-gray-500 text-center">
                {`The name in the Onboarding Form does not matches with the name
                mentioned in the ${DocType}. `}
              </div>
              <div>
                <div className="w-full border-gray-300 rounded-lg p-2 text-gray-500 text-center">
                  Contact Auction Bazaar here
                </div>
                <div className="w-full border-gray-300 rounded-lg p-2 text-gray-500 text-center">
                  Phone Number-{" "}
                  <span className="text-blue-300">8370969696</span>
                </div>
                <div className="w-full border-gray-300 rounded-lg p-2 text-gray-500 text-center">
                  Email-
                  <span className="text-blue-300">
                    contact@auctionbazaar.com
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NameMismatchModal;
